import type { SVGProps } from "react";

const SettingsIcon = ({
  width = 30,
  height = 30,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M21.913 13.75H8.163A5.614 5.614 0 0 1 2.5 8.125 5.613 5.613 0 0 1 8.163 2.5h13.75a5.625 5.625 0 0 1 0 11.25ZM18.75 8.125a3.125 3.125 0 1 0 6.25 0 3.125 3.125 0 0 0-6.25 0Z"
    />
    <path
      fill="#000"
      d="M21.913 27.5H8.163A5.614 5.614 0 0 1 2.5 21.875a5.612 5.612 0 0 1 5.663-5.625h13.75a5.625 5.625 0 0 1 0 11.25ZM5 21.875a3.125 3.125 0 1 0 6.25 0 3.125 3.125 0 0 0-6.25 0Z"
      opacity={0.3}
    />
  </svg>
);
export default SettingsIcon;
